export const FACEBOOK_HIGH_BID_THRESHOLD = 50;

const NON_MONETARY_BID_STRATEGIES = ['LOWEST_COST_WITHOUT_CAP', 'LOWEST_COST_WITH_MIN_ROAS'];

function isFacebookPlatform(platform) {
  return ['facebook', 'fb'].includes(String(platform || '').toLowerCase());
}

export function isFacebookHighBid({ platform, bidStrategy, amount }) {
  const numericAmount = Number(amount);
  return (
    isFacebookPlatform(platform) &&
    !NON_MONETARY_BID_STRATEGIES.includes(bidStrategy) &&
    Number.isFinite(numericAmount) &&
    numericAmount >= FACEBOOK_HIGH_BID_THRESHOLD
  );
}

export function getFacebookHighBidItems(items = []) {
  return items.filter(isFacebookHighBid);
}

export function confirmFacebookHighBid(vm, items = []) {
  const highBidItems = getFacebookHighBidItems(items);
  if (!highBidItems.length) {
    return Promise.resolve();
  }

  const detail = highBidItems
    .slice(0, 5)
    .map((item) => `${item.name || '广告组'}：${item.currencySymbol || '$'}${Number(item.amount).toFixed(2)}`)
    .join('；');
  const rest = highBidItems.length > 5 ? `；另有 ${highBidItems.length - 5} 个广告组` : '';

  return vm.$confirm(
    `本次操作中有 ${highBidItems.length} 个广告组的出价达到或超过 50 美元（${detail}${rest}），高出价可能导致广告花费快速增加，请确认是否继续。`,
    'Facebook 高出价警示',
    {
      confirmButtonText: '确认继续',
      cancelButtonText: '取消',
      type: 'warning',
    },
  );
}
